import React from 'react';
import { PlusIcon } from 'lucide-react';
import { PageHeader } from '../components/ui/PageHeader';
import { ButtonLink } from '../components/ui/Button';
import { ClaimsTable } from '../components/claims/ClaimsTable';
import { claims } from '../data/claims';
export function Claims() {
  return <>
      <PageHeader title="Claims" subtitle="View and manage all claims" actions={<ButtonLink to="/claims/create" data-id="element-490" data-mp="1ukvoloj8zxn0">
            <PlusIcon className="h-4 w-4" data-id="element-491" data-mp="1um6qtjx1oxc0" />
            File a Claim
          </ButtonLink>} data-id="element-489" data-mp="16thxtn0qwa45" />
      <div className="flex flex-1 flex-col bg-white px-6 py-5" data-id="element-492" data-mp="1zkrvpwn8s56s">
        <ClaimsTable claims={claims} data-id="element-493" data-mp="1lr0sf603thji" />
      </div>
    </>;
}